import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const tokenStr: string | null = localStorage.getItem('tokenObj');
        if (tokenStr) {
            try {
                const tokenObj = JSON.parse(tokenStr);
                if (tokenObj?.access_token) {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `Bearer ${tokenObj.access_token}`
                        }
                    });
                }
            } catch (e) {
                console.error('Token inválido en localStorage', e);
            }
        }
        return next.handle(request);
    }
}